import { render, staticRenderFns } from "./ListMailAddresses.vue?vue&type=template&id=79e72ae6&scoped=true&"
import script from "./ListMailAddresses.vue?vue&type=script&lang=ts&"
export * from "./ListMailAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e72ae6",
  null
  
)

export default component.exports